import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@chatterbug/aaron'

const AchievementWidgetSkeleton = ({
  headerSection,
  bodySection,
  footerSection,
  ...rest
}) => {
  return (
    <Box
      boxShadow="overlay"
      bg="white100"
      height="100%"
      p={{ _: '2x', tablet: '3x' }}
      borderRadius="1x"
      {...rest}
    >
      <Box>{headerSection}</Box>
      <Box mt="2x">{bodySection}</Box>
      <Box>{footerSection}</Box>
    </Box>
  )
}

AchievementWidgetSkeleton.propTypes = {
  headerSection: PropTypes.any,
  bodySection: PropTypes.any,
  footerSection: PropTypes.any,
}

export default AchievementWidgetSkeleton
